import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0466331d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PC商城", -1))

import { DesktopOutlined } from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PCMall',
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props



const toPCMall = () => {
  window.open(location.origin + '/pc-mall/');
};

return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "pc-mall",
        onClick: toPCMall
      }, [
        _createVNode(_unref(DesktopOutlined)),
        _hoisted_1
      ]))
    : _createCommentVNode("", true)
}
}

})